export default "__VITE_ASSET__CGAgkWrl__"